import { useEffect } from 'react';
import { Capacitor } from '@capacitor/core';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import { doc, setDoc } from 'firebase/firestore';
import { db, auth } from '../firebaseConfig';

const VAPID_KEY = 'BHvhrLe5w8kT93btr26g5uH6SYVAkl9TQmETl9mlPsHghbjnoCSZx6lyzrj1cPGOodOw1i8j29lPb4ocXqDBR9k';

export default function useRegisterFcmToken() {
 useEffect(() => {
  // 🛑 Disable Firebase Web Messaging inside mobile app (Android/iOS WebView)
  if (Capacitor.getPlatform() !== 'web') {
    console.log("🚫 Skipping Firebase Web Messaging (mobile app uses Capacitor PushNotifications).");
    return;
  }

  // 🌐 Desktop web: enable Firebase Web Messaging
  const registerFcm = async () => {
    try {
      const user = auth.currentUser;
      if (!user) return;
      if (!VAPID_KEY) return;

      const messaging = getMessaging();
      const token = await getToken(messaging, { vapidKey: VAPID_KEY });

      console.log("🌐 Web FCM token:", token);

      await setDoc(doc(db, 'users', user.uid), { pushToken: token, fcmToken: token }, { merge: true });

      onMessage(messaging, (payload) => {
        console.log("🔔 Web foreground message:", payload);
      });

    } catch (err) {
      console.error("Failed to register web FCM token:", err);
    }
  };

  registerFcm();
}, []);

}
